"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  uniqueId: 1,
  root: "/mia/oslofjord",
  name: "oslofjord",
  abbr: "MIA",
  title: "Oslofjordmuseet",
  imageUrl: "https://dms-cf-04.dimu.org/image/022waz7stTgb",
  theme: {
    primaryColor: "#99cbcc"
  },
  apps: [{
    icon: "m24",
    layout: "finder",
    ownerId: 1,
    url: "/mia/m24/",
    title: "Museum24"
  }, {
    icon: "dm",
    layout: "finder",
    ownerId: 1,
    url: "/mia/dm/",
    title: "DigitaltMuseum"
  }, {
    icon: "kp",
    layout: "finder",
    ownerId: 1,
    url: "/mia/kp/",
    title: "KulturPunkt"
  }]
};
exports.default = _default;
module.exports = exports.default;